import {Injectable} from "@angular/core";
import {HttpClient, HttpResponse} from "@angular/common/http";
import {AnnouncementSummary, ServerConstantsService} from "../shared";
import {Observable} from "rxjs/Observable";

@Injectable()
export class AnnouncementService {
  private resourceUrl: string;
  ServerConstants: any;

  constructor (
    private http: HttpClient,
    private serverConstantsService: ServerConstantsService
  ) {
    this.ServerConstants = serverConstantsService.getConstants();
    this.resourceUrl = this.ServerConstants.SERVER_API_URL + '/announcements';
  }

  findAllAnnouncements(pageNumber: number, pageSize: number): Observable<any> {
    return this.http.get<any>(`${this.resourceUrl}/getAllAnnouncements?page=${pageNumber}&size=${pageSize}`,{ observe: 'response' });
  }

  save(announcementSummary:AnnouncementSummary): Observable<HttpResponse<AnnouncementSummary>>{
    return this.http.post<AnnouncementSummary>(`${this.resourceUrl}/save`, announcementSummary, { observe: 'response' });
  }
}



// WEBPACK FOOTER //
// ./src/app/Announcements/announcements.service.ts